import { Link } from "react-router-dom";

// Site-wide announcement shown above the header on every page.
export function PolygonTransitionBanner() {
  return (
    <section className="transition-banner" role="region" aria-label="Important update">
      <div className="transition-banner__inner">
        <p className="transition-banner__title">
          <span className="transition-banner__tag">Important Update</span>
          Wax Creator is transitioning to Polygon-only support.
        </p>
        <p className="transition-banner__body">
          Unfortunately, the WAX ecosystem has not developed to the level needed to support our long-term goals.
          Polygon offers the scalability, infrastructure, and global reach necessary for us to continue growing and
          supporting creators at scale.
        </p>
        <Link to="/create/polygon" className="transition-banner__cta">
          Create on Polygon →
        </Link>
      </div>
    </section>
  );
}
